import _ from 'lodash';
import HelperGeneral from '../../../../helpers/HelperGeneral';
import {setBasketList, setRightBasketModal} from '../../../../services/redux/actions/BasketAction';
import {Modal} from 'antd';
import UserInfo from "../../../auth/UserInfo";
import Api from "../../../../services/Api";
import userInfo from "../../../auth/UserInfo";

const BasketInfo = {
    setBasketItem: function (item, quantity = 1) {
        // const user = UserInfo.info();
        // const newTotalPoint = BasketInfo.getBasketTotalPoint() + parseInt(item.productPoint);

        // Yeni
        const basketRaw = localStorage.getItem("basketList");
        const basket = basketRaw ? JSON.parse(basketRaw) : { products: [] };

        const products = Array.isArray(basket.products) ? basket.products : [];

        const exists = products.some(p => Number(p.product_id) === Number(item?.id));

        if (exists) {
            HelperGeneral.alert("Ürün sepette bulunmaktadır", "warning");
            return;
        }

        const data = {
            product_id: item?.id,
            quantity: quantity,
            type: 1,
            uniqid: localStorage.getItem("uniqid"),
            gift_product: 1
        };

        Api.addBasket(data).then((res) => {
            Api.getBasket().then((response) => {
                if (response?.data.products?.length > 0) {
                    localStorage.setItem("basketList", JSON.stringify(response?.data));
                    setBasketList(response?.data?.products);
                    setRightBasketModal(true);
                    try {
                        const productCodeRaw = item?.product_code || item?.code || item?.productCode || item?.id;
                        const productCode = (typeof window.normalizeProductCode === 'function')
                            ? window.normalizeProductCode(productCodeRaw)
                            : String(productCodeRaw || '').padStart(15, '0');

                        if (typeof window.soulTrackEvent === 'function') {
                            window.soulTrackEvent({
                                eventName: 'add_to_cart',
                                ecommerce: {
                                    currency: 'TRY',
                                    value: '0',
                                    basket_id: localStorage.getItem('uniqid') || '',
                                    items: [{
                                        code: productCode,
                                        item_name: item?.name || item?.product_name || '',
                                        quantity: Number(quantity || 1),
                                        item_image: item?.images?.[0]?.w100x100 || item?.image || undefined,
                                        url: item?.url || undefined,
                                    }],
                                },
                            });
                        }
                    } catch (e) {
                        // best-effort
                    }
                } else {
                    localStorage.removeItem("basketList");
                    setBasketList([]);
                }
            }).catch((e) => {
                HelperGeneral.alert(e);
            });
        });
        // if (true) {
        //     item.quantity = quantity;
        //
        //     const basketList = this.getBasketAll();
        //     if (basketList.products.length < 1) {
        //         this.setBasketItems([item]);
        //     } else {
        //         const basketList = this.getBasketAll()
        //         const check = _.findIndex(basketList, ['id', item.id]);
        //         if (check > -1) {
        //             HelperGeneral.alert('Ürün sepette bulunmaktadır', 'warning');
        //         } else {
        //             basketList.push(item);
        //             this.setBasketItems(basketList);
        //         }
        //     }
        // } else {
        //     HelperGeneral.alert('Hediye almak için yeterli puanınız bulunmamaktadır', 'warning');
        // }
    },
    getBasketAll() {
        //sepet listesi
        // let basketList = localStorage.getItem('basketList');
        // basketList = basketList ? JSON.parse(basketList) : [];
        Api.getBasket(UserInfo.info('company_id')).then((response) => {
            return response?.data;
        })
    },
    setBasketItems(items) {
        //sepet listesini toplu güncelleme
        setBasketList(items);
        return localStorage.setItem('basketList', JSON.stringify(items));
    },
    getBasketCount() {
        //sepette bulunan toplam ürün
        // Api.getBasket(UserInfo.info('company_id')).then((response) => {
        //     return response?.data?.products.length;
        // })
        // const count = this.getBasketAll().products.length;
        // return count;
    },
    removeBasketAll() {
        //tüm sepeti silme
        return localStorage.removeItem('basketList');
    },
    removeBasketItem(itemId) {
        const data = {
            product_id: itemId,
            quantity: 0,
            type: 1,
            uniqid: localStorage.getItem("uniqid"),
            gift_product: 1
        };

        Api.addBasket(data).then((res) => {
            Api.getBasket(UserInfo.info('company_id')).then((response) => {
                if (response?.data.products?.length > 0) {
                    localStorage.setItem("basketList", JSON.stringify(response.data));
                    setBasketList(response.data.products);
                } else {
                    localStorage.removeItem("basketList");
                    setBasketList([]);
                }
            }).catch((e) => {
                HelperGeneral.alert(e);
            });
        });
        //sepetteki ürünü silme
        // const basketList = this.getBasketAll();
        // if (basketList?.length > 0) {
        //     setTimeout(() => {
        //         Modal.confirm({
        //             type: 'warning',
        //             content: 'Ürünü sepetten silmek istediğinize emin misiniz?',
        //             onOk() {
        //                 const newBasketList = _.reject(basketList, ['id', itemId]);
        //                 BasketInfo.setBasketItems(newBasketList);
        //                 Modal.destroyAll();
        //             },
        //             onCancel() {
        //                 Modal.destroyAll();
        //             },
        //         })
        //     }, 100)
        // }
    },
    updateBasketItem(itemId, quantity) {
        // if (quantity < 1) {
        //     //sepetteki miktar sıfırdan küçükse ürün sepetten kaldır
        //     this.removeBasketItem(itemId);
        // } else {
        //     //sepetteki ürünün miktarını güncelleme
        //     const basketList = this.getBasketAll();
        //
        //     if (basketList.length > 0) {
        //         const index = _.findIndex(basketList, ['id', itemId]);
        //         if (index > -1) {
        //             const user = UserInfo.info();
        //             const newTotalPoint = BasketInfo.getBasketTotalPoint() + parseInt(basketList[index]?.gift_point);
        //             // if (user?.customerScore < newTotalPoint && basketList[index].quantity < quantity) {
        //             //     return HelperGeneral.alert('Hediye almak için yeterli puanınız bulunmamaktadır', 'warning');
        //             // }
        //             basketList[index].quantity = quantity;
        //             this.setBasketItems(basketList);
        //         }
        //     }
        // }
    },
    getBasketTotalPoint() {
        //Toplam sepet puanı
        let totalPoint = 0;
        const basketList = JSON.parse(localStorage.getItem("basketList"));
        if (basketList?.products.length > 0) {
            totalPoint = basketList?.products.reduce((sum, value) => {
                return sum + parseInt(value?.quantity) * parseInt(value?.gift_point);
            }, 0)
        }
        return totalPoint;
    },
}
export default BasketInfo;
